import { TextField } from "@material-ui/core";

const _spacing = "10px";

const QdlForm = props => {
  const handleChange = e => {
    const name = e.target.name;
    const value = e.target.value;
    props.setQueryState(prevState => {
      return { ...prevState, [name]: value };
    });
  };

  return (
    <div
      data-testid="qdl-form"
      id="bottom-half"
      style={{ display: "flex", flexDirection: "column", rowGap: "10px" }}
    >
      {props.children}
      <div
        id="group1"
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          border: "1px solid black",
          justifyContent: "space-between",
          padding: _spacing,
        }}
      >
        <TextField
          variant="outlined"
          data-cy="pid"
          inputProps={{ "data-cy": "pid-input" }}
          InputLabelProps={{ shrink: true, "data-cy": "pid-input-label" }}
          margin="dense"
          id="pid-id"
          label="Personal Identification Number (exactly 8 characters)"
          helperText={
            props?.queryState?.pid?.length > 0 &&
            props?.queryState?.pid?.length !== 8
              ? "Please enter exactly 8 characters"
              : null
          }
          error={
            props?.queryState?.pid?.length > 0 &&
            props?.queryState?.pid?.length !== 8
              ? true
              : false
          }
          value={props?.queryState?.pid || ""}
          onChange={handleChange}
          name="pid"
          style={{ width: "45%" }}
        />
      </div>
    </div>
  );
};

export default QdlForm;
